import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginAPI } from "../../../redux/slices/authSlice";
import { useFormik } from "formik";
import { loginSheme } from "../../../schemas/loginSchema.js";
import { errorHandler } from "../../../constants/base.js";
import { toast } from "react-toastify";

const SampleSignInForm = () => {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  const dispatch = useDispatch();
  const loading = useSelector((state) => state.AuthSlice.loading);

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSheme,
    onSubmit: async (values) => {
      const res = await dispatch(loginAPI(values));

      if (res.type === "loginAPI/fulfilled") {
        if (res?.payload?.status === 200 || res?.payload?.status === true) {
          const role = res?.payload?.data?.role?.name;


          if (role === "professional") {
            navigate("/professional/services");
          } else if (role === "corporate") {
            navigate("/corporate/dashboard");
          } else if (role === "user") {
            navigate("/user/chat");
          } else if (role === "employee") {
            navigate("/employee/chat");
          } else if (role === "admin") {
            navigate("/admin/dashboard");
          }
        }
      } else if (res.type === "loginAPI/rejected") {
        if (res?.payload?.data?.user_id) {
          navigate("/sign-up/email-varification");
          toast.error(res?.payload?.message);
        } else {
          toast.error(res?.payload?.message);
        }
      } else {
        toast.error("Sorry, something went wrong!");
      }
    },
  });

  return (
    <div className="signup-form xl-pt-5 xl-pb-5 lg-pt-5 lg-pb-5 md-pt-5 md-pb-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-4 col-lg-4 col-md-8">
            <h1 className="main-form-heading">Sign In</h1>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-4 col-lg-4 col-md-8 auth-form-card">
            <form className="needs-validation" onSubmit={formik.handleSubmit}>
              <div className="mb-3 custom-input-box">
                <input
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className={`form-control ${formik.errors.email && formik.touched.email
                    ? "input-error"
                    : ""
                    }`}
                  placeholder="Enter Your Email"
                  onBlur={formik.handleBlur}
                />
                {formik.errors.email && formik.touched.email && (
                  <p className="danger-text">{formik.errors.email}</p>
                )}
              </div>

              <div className="custom-input-box">
                <input
                  type={passwordVisible ? "text" : "password"}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  className={`form-control pass-input ${formik.errors.password && formik.touched.password
                    ? "input-error"
                    : ""
                    }`}
                  placeholder="Enter Password"
                  onBlur={formik.handleBlur}
                />
                <i
                  className={`fa-solid ${passwordVisible ? "fa-eye-slash" : "fa-eye"
                    }`}
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                ></i>
                {formik.errors.password && formik.touched.password && (
                  <p className="danger-text">{formik.errors.password}</p>
                )}
              </div>

              <div className="forgot-password-box">
                <Link to="/forgot-password">
                  <span>Forgot password?</span>
                </Link>
              </div>

              <div className="submit-btn-form">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {!loading ? (
                    "Log In"
                  ) : (
                    <i
                      style={{ fontSize: "22px" }}
                      className="fa-solid fa-spinner fa-spin"
                    ></i>
                  )}
                </button>
              </div>
            </form>

            <div className="not-a-member-box text-center">
              <p className="member-text">
                Not a member? <Link to="/user/signup">Sign Up</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SampleSignInForm;
